import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import find from 'lodash/find'
import get from 'lodash/get'
import memoize from 'lodash/memoize'
import uniq from 'lodash/uniq'
// import toPairs from 'lodash/toPairs'
import every from 'lodash/every'

import { Link } from 'react-router-dom'

import { toFormattedDateStr } from 'utils/content'
import { formatPrice } from 'utils/content';

import {
  PRICE_TYPES_IN_ORDER,
  constructEventContestPriceBundles,
  getProductsOfPriceTypeAndActivity,
  createOrderRowsOfEvent,
  contestPriceRowsIsValid,
} from 'selectors/event'

import { addOrderRows } from 'actions'

import {
  fetchCustomerEventPriceTypeProducts,
  fetchProductArticles,
} from 'api'

import { Translate } from 'containers/translates'
import { waitUntilPromiseIsResolved } from 'containers/hoc'
import SigninOrRegister from 'containers/steps/SigninOrRegister'

import { FormButton } from '../forms/Form'
import { SecondaryButton, DarkButton, ButtonContainer } from '../buttons'

import { CardList } from 'components/Card'
import ProductCard from 'components/ProductCard'
import ProductCategoryCard from 'components/ProductCategoryCard'

import FieldInputsContext from 'components/fields/FieldInputsContext'
import { OrderRowTable } from 'components/OrderRows'

import LoadingIndicator from 'components/spinners'

import WizardStepWrapper from './WizardStepWrapper'
import WizardStepBoxes, { WizardStepBox, WizardStepArrow } from './WizardStepBoxes'
import EventDetailsForm, { EventDetailsFormContent } from './EventDetailsForm'
import EventContestsForm from './EventContestsForm'
import PriceTypeProductFields from './PriceTypeProductFields'

import { PriceBundlesList, PriceBundlesListItem } from './PriceBundlesList'

import routes from 'routes'
import EventStateContext from './EventStateContext';

function contestIsValid(contest) {
  return (
    contest.name.length > 0 &&
    contest.prices
      .filter((price) => {
        return (
          price.isSelected &&
          contestPriceRowsIsValid(price.rows)
        )
      }).length > 0
  )
}


const
  INTRODUCTION = 'INTRODUCTION',
  SIGNIN = 'SIGNIN',
  EVENT_DETAILS = 'EVENT_DETAILS',
  EVENT_CONTESTS = 'EVENT_CONTESTS',
  EVENT_SUMMARY = 'EVENT_SUMMARY',
  PRICE_TYPE_PRODUCTS_SUMMARY = 'PRICE_TYPE_PRODUCTS_SUMMARY',
  PRICE_TYPE_PRODUCT_CATEGORY_SELECTION = 'PRICE_TYPE_PRODUCT_CATEGORY_SELECTION',
  PRICE_TYPE_PRODUCT_SELECTION = 'PRICE_TYPE_PRODUCT_SELECTION',
  PRICE_TYPE_PRODUCT_FIELD_SELECTION = 'PRICE_TYPE_PRODUCT_FIELD_SELECTION',
  ORDER_SUGGESTION = 'ORDER_SUGGESTION',
  COMPLETE = 'COMPLETE'


const memoizedConstructEventContestPriceBundles = memoize(constructEventContestPriceBundles)


const OrderRows = waitUntilPromiseIsResolved(
  ({ orderRows }) => fetchProductArticles({
    articleIds: orderRows.map(row => row.articleId)
  }),
  (data) => {
    return {
      productArticles: data.items
    }
  }
)(connect((state) => ({
  productAttributes: state.productAttributes,
}))((props) => (
  <OrderRowTable
    {...props}
    showTableHead={false}
    isEditable={false}
  />
)))


export class EventToOrderWizard extends Component {
  static propTypes = {
    onComplete: PropTypes.func.isRequired,
    isSignedIn: PropTypes.bool.isRequired,
    customerId: PropTypes.number,
    onCancel: PropTypes.func.isRequired,
    priceTypeProductBundles: PropTypes.array.isRequired,
    activities: PropTypes.array.isRequired,
    productFields: PropTypes.array.isRequired,
    nextOrderRowId: PropTypes.number.isRequired,
    addOrderRows: PropTypes.func.isRequired
  }

  static contextType = EventStateContext

  state = {
    step: INTRODUCTION,
    visitedSteps: [],
    currentPriceType: null,
    priceTypeSelections: {},
    orderRows: null,
    isCreatingOrderRows: false,
    // priceTypeSelections: { "rows": { "productCategoryId": 3, "productId": 3288, "productArticleIds": [10852, 10851, 10850, 10849, 10848], "productFieldInputs": { "8": { "textTemplate": { "variables": [{ "suggestions": [], "name": "eventName", "valueRules": [], "label": "Evenemang" }, { "suggestions": [], "name": "eventYear", "valueRules": [], "label": "År" }, { "suggestions": [], "name": "eventContestName", "valueRules": [], "label": "Klass" }, { "suggestions": [], "name": "eventContestPosition", "valueRules": [], "label": "Placering" }], "placeholder": "Lundgrens-cupen 2018\nP10 1:a", "id": 1, "template": "${eventName} ${eventYear}\n${eventContestName} ${eventContestPosition}", "name": "Evenemang, klass, placering" }, "textTemplateId": 1, "value": "Testevent 2019\n<P12, F12, Trixtävling> <1:a, 2:a, ..>" } } }, "rowsAndCopies": { "productCategoryId": 2, "productId": 3480, "productArticleIds": [11357, 11358, 11359], "productFieldInputs": { "1": { "selectionId": 1, "settingInputs": [] }, "2": { "selectionId": 1302, "settingInputs": [] }, "5": { "textTemplate": { "variables": [{ "suggestions": [], "name": "eventName", "valueRules": [], "label": "Evenemang" }, { "suggestions": [], "name": "eventYear", "valueRules": [], "label": "År" }, { "suggestions": [], "name": "eventContestName", "valueRules": [], "label": "Klass" }, { "suggestions": [], "name": "eventContestPosition", "valueRules": [], "label": "Placering" }], "placeholder": "Lundgrens-cupen 2018\nP10 1:a", "id": 1, "template": "${eventName} ${eventYear}\n${eventContestName} ${eventContestPosition}", "name": "Evenemang, klass, placering" }, "textTemplateId": 1, "value": "Testevent 2019\n<P12, F12, Trixtävling> <1:a, 2:a, ..>" } } }, "copies": { "productCategoryId": 2, "productId": 3482, "productArticleIds": [11363, 11364, 11365], "productFieldInputs": { "1": { "selectionId": 1, "settingInputs": [] }, "2": { "selectionId": 1302, "settingInputs": [] }, "5": { "textTemplate": { "variables": [{ "suggestions": [], "name": "eventName", "valueRules": [], "label": "Evenemang" }, { "suggestions": [], "name": "eventYear", "valueRules": [], "label": "År" }], "placeholder": "Stockholmsloppet 2019", "id": 2, "template": "${eventName} ${eventYear}", "name": "Evenemang & År" }, "textTemplateId": 2, "value": "Testevent 2019" } } } },
  }

  syncEvent = () => this.context.sync(this.props.customerId)

  setStep = (nextStep) => {
    this.setState({
      step: nextStep,
      visitedSteps: [
        ...this.state.visitedSteps,
        this.state.step
      ]
    })
  }

  getEventContestPriceBundlesOfType = (priceType) => memoizedConstructEventContestPriceBundles(
    this.context.event.contests
  ).filter((priceBundle) => priceBundle.priceType === priceType)

  getOrderedPriceTypes = () => (
    PRICE_TYPES_IN_ORDER.filter((priceType) => (
      this.getEventContestPriceBundlesOfType(priceType).length > 0
    ))
  )

  getCurrentEventContestPriceBundles = () => (
    this.getEventContestPriceBundlesOfType(
      this.state.currentPriceType
    )
  )

  renderPriceTypeProductsSummary = () => {
    const priceTypeBundles = this.getOrderedPriceTypes().map((
      priceType,
      // priceTypeIndex
    ) => {
      const productId = get(this.state.priceTypeSelections, [priceType, "productId"])
      const product = productId !== undefined ? this._getPriceTypeProductBundleOfProductId(productId).product : undefined

      return ({
        priceType,
        priceBundles: this.getEventContestPriceBundlesOfType(priceType),
        product,
      })
    }
    )

    return (
      <PriceBundlesList>
        {priceTypeBundles.map((priceTypeBundle) => (
          <PriceBundlesListItem
            key={priceTypeBundle.priceType}
            {...priceTypeBundle}
            onClick={() => {
              this.setState({ currentPriceType: priceTypeBundle.priceType })
              this.setStep(PRICE_TYPE_PRODUCT_CATEGORY_SELECTION)
            }}
          />
        ))}
      </PriceBundlesList>
    )
  }

  _getPriceTypeProductsOfPriceType = memoize((priceType) => (
    getProductsOfPriceTypeAndActivity(
      this.props.priceTypeProductBundles,
      priceType,
      this.context.event.activityId
    )
  ))

  _getPriceTypeProductCategoryIdsOfPriceType = memoize((priceType) => (
    uniq(
      this._getPriceTypeProductsOfPriceType(priceType)
        .map((product) => product.mainCategoryId)
    )
  ))

  setCurrentPriceTypeSelectionPayload = (selectionPayload) => {
    this.setState({
      priceTypeSelections: {
        ...this.state.priceTypeSelections,
        [this.state.currentPriceType]: {
          ...(this.state.priceTypeSelections[this.state.currentPriceType] || {}),
          ...selectionPayload
        }
      }
    })
  }

  _getPriceTypeProductBundleOfProductId = memoize(
    (productId) => find(
      this.props.priceTypeProductBundles,
      (priceTypeProductBundle) => priceTypeProductBundle.productId === productId
    )
  )

  _getCurrentPriceTypeProduct = () => {
    const foundPriceTypeProductBundle = this._getPriceTypeProductBundleOfProductId(
      this.state.priceTypeSelections[this.state.currentPriceType].productId
    )

    return foundPriceTypeProductBundle !== undefined ? foundPriceTypeProductBundle.product : undefined
  }

  priceTypeSelectionsIsComplete = () => {
    return every(
      this.getOrderedPriceTypes().map((priceType) => {
        const priceTypeSelection = this.state.priceTypeSelections[priceType]

        const priceTypeIsComplete = (
          get(priceTypeSelection, "productCategoryId") !== undefined &&
          get(priceTypeSelection, "productId") !== undefined &&
          get(priceTypeSelection, "productArticleIds") !== undefined &&
          get(priceTypeSelection, "productFieldInputs") !== undefined
        )

        return priceTypeIsComplete
      })
    )
  }

  renderCurrentPriceTypeProductCategorySelection = () => {
    const priceTypeProductCategoryIds = this._getPriceTypeProductCategoryIdsOfPriceType(this.state.currentPriceType)
    return (
      <CardList>
        {
          priceTypeProductCategoryIds.map((productCategoryId) => (
            <ProductCategoryCard
              key={productCategoryId}
              productCategoryId={productCategoryId}
              size="small"
              onClick={() => {
                this.setCurrentPriceTypeSelectionPayload({ productCategoryId })
                this.setStep(PRICE_TYPE_PRODUCT_SELECTION)
              }}
            />
          ))
        }
      </CardList>
    )
  }

  renderCurrentPriceTypeProductSelection = () => {
    const currentPriceTypeProductCategoryId = this.state.priceTypeSelections[this.state.currentPriceType].productCategoryId
    const priceTypeProducts = this._getPriceTypeProductsOfPriceType(
      this.state.currentPriceType
    ).filter((product) => product.mainCategoryId === currentPriceTypeProductCategoryId)

    return (
      <CardList>
        {
          priceTypeProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              size="small"
              onClick={() => {
                this.setCurrentPriceTypeSelectionPayload({
                  productId: product.id,
                  productArticleIds: product.articleIds,
                })
                this.setStep(PRICE_TYPE_PRODUCT_FIELD_SELECTION)
              }}
            />
          ))
        }
      </CardList>
    )
  }


  renderCurrentPriceTypeProductFieldSelection = (t) => {
    const currentPriceTypeProduct = this._getCurrentPriceTypeProduct()

    return (
      <PriceTypeProductFields
        productFieldIds={currentPriceTypeProduct.productFieldIds}
        event={this.context.event}
        eventContestPriceTypeBundles={this.getCurrentEventContestPriceBundles()}
      >
        {(productFieldInputs) => (
          <React.Fragment>
            <hr />
            <SecondaryButton onClick={() => {
              this.setCurrentPriceTypeSelectionPayload({ productFieldInputs })
              this.setStep(PRICE_TYPE_PRODUCTS_SUMMARY)

            }}>{t('submitButton.label')}</SecondaryButton>
          </React.Fragment>
        )}
      </PriceTypeProductFields>
    )
  }

  createOrderRows = (cb) => (
    this.setState({
      isCreatingOrderRows: true
    }, () => {
      createOrderRowsOfEvent(
        this.context.event,
        this.state.priceTypeSelections,
        this.props.nextOrderRowId
      )
        .then((orderRows) => this.setState({
          isCreatingOrderRows: false,
          orderRows
        }, cb))
    })
  )

  renderOrderSuggestion = (t) => {

    if (this.state.orderRows === null) {
      return <LoadingIndicator />
    }

    const orderSum = this.state.orderRows.reduce((orderSumAccum, orderRow) => (
      orderSumAccum +
      (orderRow.quantity * orderRow.unitPrice)
    ), 0)

    return (
      <React.Fragment>
        <OrderRows
          orderRows={this.state.orderRows}
        />
        <div className="mt-3 text-right">
          <strong>{t('orderSum', { value: formatPrice(orderSum, 'kr') })}</strong>
        </div>
        <div className="mt-3">
          <ButtonContainer>
            <DarkButton onClick={() => {
              this.setState({ orderRows: null })
              this.setStep(PRICE_TYPE_PRODUCTS_SUMMARY)
            }}>
              {t('backButton.label')}
            </DarkButton>
            <SecondaryButton onClick={() => {
              this.props.addOrderRows(this.state.orderRows)
              setTimeout(() => this.setStep(COMPLETE), 500)
            }}>{t('submitButton.label')}</SecondaryButton>
          </ButtonContainer>
        </div>
      </React.Fragment>
    )
  }

  renderEventContests = () => {
    const haveValidContests = this.context.event.contests
      .filter(contestIsValid).length > 0

    return (
      <WizardStepWrapper
        ns="eventContests"
        withAssistantComment
        assistantCommentStartOpen
        headerContext={{
          eventNameAndYear: this.context.event.name
        }}
      >
        {(t) => (
          this.context.isSyncing ?
            (
              <LoadingIndicator />
            ) :
            (
              <React.Fragment>
                <EventContestsForm
                  t={t}
                  contests={this.context.event.contests}
                  onChange={(contests) => {
                    this.context.set({ contests })
                  }}
                />
                <hr />
                <SecondaryButton
                  onClick={() => {
                    this.syncEvent()
                      .then(() => this.setStep(EVENT_SUMMARY))
                  }}
                  disabled={!haveValidContests}
                >
                  {t('button.label')}
                </SecondaryButton>
              </React.Fragment>
            )
        )}
      </WizardStepWrapper>
    )
  }

  render() {
    return {
      [INTRODUCTION]: () => (
        <WizardStepWrapper
          ns="introduction"
          headerContext={{ event: this.context.event }}
          withAssistantComment
          assistantCommentStartOpen
        >
          {(t) => (
            <WizardStepBoxes>
              <WizardStepBox
                highlighted
                onClick={() => this.setStep(this.props.isSignedIn ? EVENT_DETAILS : SIGNIN)}
              >
                <div>
                  <h3>{t('stepBoxes.event.header')}</h3>
                  <p>{t('stepBoxes.event.text')}</p>
                </div>
                <div className="mt-3">
                  <SecondaryButton>{t('stepBoxes.event.buttonLabel')}</SecondaryButton>
                </div>
              </WizardStepBox>
              <WizardStepArrow disabled />
              <WizardStepBox disabled>
                <div>
                  <h3>{t('stepBoxes.products.header')}</h3>
                  <p>{t('stepBoxes.products.text')}</p>
                </div>
              </WizardStepBox>
              <WizardStepArrow disabled />
              <WizardStepBox disabled>
                <div>
                  <h3>{t('stepBoxes.order.header')}</h3>
                  <p>{t('stepBoxes.order.text')}</p>
                </div>
              </WizardStepBox>
            </WizardStepBoxes>
          )}
        </WizardStepWrapper>
      ),
      [SIGNIN]: () => (
        <WizardStepWrapper
          ns="signin"
          withAssistantComment
          assistantCommentStartOpen
        >
          {() => (
            <SigninOrRegister
              onDone={() => this.setStep(EVENT_DETAILS)}
            />
          )}
        </WizardStepWrapper>
      ),
      [EVENT_DETAILS]: () => (
        <WizardStepWrapper
          ns="eventDetails"
          withAssistantComment
          assistantCommentStartOpen
        >
          {(t) => (
            <EventDetailsForm
              event={this.context.event}
              onSubmit={(eventPayload) => {
                this.context.set(eventPayload)
                  .then(() => {
                    this.syncEvent()
                    this.setStep(EVENT_CONTESTS)
                  })
              }}
            >
              {() => (
                <React.Fragment>
                  <EventDetailsFormContent t={t} />
                  <hr />
                  <FormButton buttonComponent={SecondaryButton}>{t('button.label')}</FormButton>
                </React.Fragment>
              )}
            </EventDetailsForm>
          )}
        </WizardStepWrapper>
      ),
      [EVENT_CONTESTS]: this.renderEventContests,
      [EVENT_SUMMARY]: () => (
        <WizardStepWrapper
          ns="eventSummary"
          withAssistantComment
          assistantCommentStartOpen
          headerContext={{
            eventNameAndYear: this.context.event.name
          }}
        >
          {(t) => (
            <WizardStepBoxes>
              <WizardStepBox
                onClick={() => this.setStep(EVENT_DETAILS)}
              >
                <div>
                  <h3>{this.context.event.name}</h3>
                  <p>
                    {find(this.props.activities, (a) => a.id === this.context.event.activityId).name} <br />
                    {toFormattedDateStr(this.context.event.date)} <br />
                    {this.context.event.contests.map(({ name }) => name).join(", ")}
                  </p>
                </div>
                <div className="mt-3">
                  <DarkButton outline>{t('stepBoxes.event.buttonLabel')}</DarkButton>
                </div>
              </WizardStepBox>
              <WizardStepArrow />
              <WizardStepBox
                highlighted
                onClick={() => this.setStep(PRICE_TYPE_PRODUCTS_SUMMARY)}
              >
                <div>
                  <h3>{t('stepBoxes.products.header')}</h3>
                  <p>{t('stepBoxes.products.text')}</p>
                </div>
                <div className="mt-3">
                  <SecondaryButton>{t('stepBoxes.products.buttonLabel')}</SecondaryButton>
                </div>
              </WizardStepBox>
              <WizardStepArrow disabled />
              <WizardStepBox disabled>
                <div>
                  <h3>{t('stepBoxes.order.header')}</h3>
                  <p>{t('stepBoxes.order.text')}</p>
                </div>
              </WizardStepBox>
            </WizardStepBoxes>
          )}
        </WizardStepWrapper>
      ),
      [PRICE_TYPE_PRODUCTS_SUMMARY]: () => (
        this.priceTypeSelectionsIsComplete() ?
          (
            <WizardStepWrapper
              ns="priceTypeProductsSummary__complete"
              withAssistantComment
              assistantCommentStartOpen
              headerContext={{
                eventNameAndYear: this.context.event.name
              }}
            >
              {(t) => (
                <div style={{ position: "relative" }}>
                  {this.renderPriceTypeProductsSummary(t)}
                  <div className="mt-3">
                    <ButtonContainer>
                      <DarkButton onClick={() => {
                        this.setStep(EVENT_DETAILS)
                      }}>
                        {t('backButton.label')}
                      </DarkButton>
                      <SecondaryButton onClick={() => {
                        this.createOrderRows(
                          () => this.setStep(ORDER_SUGGESTION)
                        )
                      }}>{t('submitButton.label')}</SecondaryButton>
                    </ButtonContainer>
                  </div>
                  {
                    this.state.isCreatingOrderRows && (
                      <div className="d-flex align-items-center" style={{
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#ffffff99',
                      }}>
                        <LoadingIndicator />
                      </div>
                    )
                  }
                </div>
              )}

            </WizardStepWrapper>
          ) : (
            <WizardStepWrapper
              ns="priceTypeProductsSummary__incomplete"
              withAssistantComment
              assistantCommentStartOpen
              headerContext={{
                eventNameAndYear: this.context.event.name
              }}
            >
              {(t) => (
                <React.Fragment>
                  {this.renderPriceTypeProductsSummary(t)}
                  <div className="mt-3">
                    <ButtonContainer>
                      <DarkButton onClick={() => {
                        this.setStep(EVENT_DETAILS)
                      }}>
                        {t('backButton.label')}
                      </DarkButton>
                      <SecondaryButton disabled>{t('submitButton.label')}</SecondaryButton>
                    </ButtonContainer>
                  </div>
                </React.Fragment>
              )}
            </WizardStepWrapper>
          )
      ),
      [PRICE_TYPE_PRODUCT_CATEGORY_SELECTION]: () => (
        <WizardStepWrapper
          ns="priceTypeProductCategorySelection"
          withAssistantComment
          assistantCommentStartOpen
          headerContext={{
            eventNameAndYear: this.context.event.name
          }}
        >
          {this.renderCurrentPriceTypeProductCategorySelection}
        </WizardStepWrapper>
      ),
      [PRICE_TYPE_PRODUCT_SELECTION]: () => (
        <WizardStepWrapper
          ns="priceTypeProductSelection"
          withAssistantComment
          assistantCommentStartOpen
          headerContext={{
            eventNameAndYear: this.context.event.name
          }}
        >
          {this.renderCurrentPriceTypeProductSelection}
        </WizardStepWrapper>
      ),
      [PRICE_TYPE_PRODUCT_FIELD_SELECTION]: () => (
        <WizardStepWrapper
          ns="priceTypeProductFieldSelection"
          withAssistantComment
          assistantCommentStartOpen
          headerContext={{
            eventNameAndYear: this.context.event.name
          }}
        >
          {this.renderCurrentPriceTypeProductFieldSelection}
        </WizardStepWrapper>
      ),
      [ORDER_SUGGESTION]: () => (
        <WizardStepWrapper
          ns="orderSuggestion"
          withAssistantComment
          assistantCommentStartOpen
          headerContext={{
            eventNameAndYear: this.context.event.name
          }}
        >
          {this.renderOrderSuggestion}
        </WizardStepWrapper>
      ),
      [COMPLETE]: () => (
        <WizardStepWrapper
          ns="complete"
          withAssistantComment
          assistantCommentStartOpen
          headerContext={{
            eventNameAndYear: this.context.event.name
          }}
        >
          {(t) => (
            <ButtonContainer>
              <SecondaryButton tag={Link} to={routes.ORDER.get()} onClick={this.props.onComplete}>
                {t('gotoOrderButton.label')}
              </SecondaryButton>
              <DarkButton tag={Link} to={routes.HOME.get()} onClick={this.props.onComplete}>
                {t('gotoHomeButton.label')}
              </DarkButton>
            </ButtonContainer>
          )}
        </WizardStepWrapper>
      ),
    }[this.state.step]()
  }
}

export default waitUntilPromiseIsResolved(
  fetchCustomerEventPriceTypeProducts,
  ({ items: priceTypeProductBundles }) => ({
    priceTypeProductBundles
  })
)(
  connect(
    (state) => ({
      isSignedIn: state.auth.isSignedIn,
      customerId: state.customer.id || undefined,
      activities: state.activities,
      productFields: state.productFields,
      nextOrderRowId: state.order.nextRowId
    }),
    {
      addOrderRows
    }
  )((props) => (
    <FieldInputsContext.Provider>
      <Translate ns="eventToOrderWizard">
        {() => (
          <EventToOrderWizard
            {...props}
          />
        )}
      </Translate>
    </FieldInputsContext.Provider>
  ))
)
